import { Action } from 'redux';
import { FILTERS_SET_ORDER_TYPE_TYPE } from '../../constants/actionTypes';
import { EOrderField } from '../../types/filters';
import { TThunkAction } from '../../types/redux';

export type TSetFavoriteOrderTypeType = 'filters/set_favorite_order_type';

export interface ISetOrderType extends Action<TSetFavoriteOrderTypeType> {
  type: TSetFavoriteOrderTypeType;
  orderField: EOrderField | null;
}

export function setOrderField(orderField: EOrderField | null): TThunkAction {
  return dispatch => {
    dispatch<ISetOrderType>({
      orderField,
      type: FILTERS_SET_ORDER_TYPE_TYPE,
    });
  };
}
